module.exports = __webpack_public_path__ + "static/media/vippscode.c00acd61.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Signup/Media/vippscode.PNG
// module id = 77
// module chunks = 0